import React, { useEffect, useState } from 'react';
import { Button, Container, Toast } from 'react-bootstrap';
import contactBgImage from '../../../server-build/Images/Contact.png';
import call from '../../Assets/Images/Call.png';
import email from '../../Assets/Images/Email1.png';
import location from '../../Assets/Images/Location.png';
import { Form } from 'react-bootstrap';
import { faChevronCircleLeft, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import add from '../../Assets/Images/Add.png';
import upload from '../../Assets/Images/Upload.png';
import FromService from '../../Services/formService';



function Contact(props) {
    var service: FromService = FromService.getInstance();
    const [selectedFile, setSelectedFile] = useState(null);
    let [abortApi, setabortApi] = useState(false);
    let [FirstName, setFirstName] = useState(false);
    let [LastName, setLastName] = useState(false);
    let [Company, setCompany] = useState(false);
    let [Mobile, setMobile] = useState(false);
    let [Email, setEmail] = useState(false);
    let [LeadSource, setLeadSource] = useState(false);
    let [Description, setDescription] = useState(false);
    let [isLoading, setIsLoading] = useState(false);
    let [showMessage, setshowMessage] = useState(null);

    let fromData = new FormData();
    fromData.append('xnQsjsdp', "e7e2f5a5c96dd4bd33ba3cefd243e353759acc866e6045371a070a09796a4de6");
    fromData.append('zc_gad', "");
    fromData.append('xmIwtLD', "f1313d76befb04581a781cd6d83ee7d88f169a2d6bf5cc31be05122227cb40357c34156d728ac7ea5db9c6c9fb8b0fb3");
    fromData.append('actionType', "TGVhZHM=");
    fromData.append('returnURL', null);
    fromData.append('First Name', "");
    fromData.append('Last Name', "");
    fromData.append('Company', "");
    fromData.append('Mobile', "");
    fromData.append('Email', "");
    fromData.append('Lead Source', "");
    fromData.append('Description', "");


    let submit = async () => {
        ClearErrors();
        let isValidate = Validate();
        if (isValidate) {
            return;
        }

        setIsLoading(true);
        await service.Form_post(fromData).then(e => {
            setIsLoading(false);
            if (e.status == 200) {
                (document.getElementById("formGridFirstName") as HTMLInputElement).value = "";
                (document.getElementById("formGridLastName") as HTMLInputElement).value = "";
                (document.getElementById("formGridEmail") as HTMLInputElement).value = "";
                (document.getElementById("formGridCompany") as HTMLInputElement).value = "";
                (document.getElementById("formGridMobile") as HTMLInputElement).value = "";
                (document.getElementById("#Query") as HTMLInputElement).value = "";
                setshowMessage(true);
            } else {
                setshowMessage(false);
            }
        })
    }

    let ClearErrors = () => {
        setFirstName(false);
        setLastName(false);
        setCompany(false);
        setMobile(false);
        setEmail(false);
        setLeadSource(false);
        setDescription(false);
        setshowMessage(null);
    }



    let Validate = () => {
        let respReturn = false;
        let firstName = (document.getElementById("formGridFirstName") as HTMLInputElement);
        if (firstName.value == undefined || firstName.value == null || firstName.value.replace(/\s/g, '').length == 0) {
            setFirstName(true);
            respReturn = true;
        } else {
            fromData.set('First Name', firstName.value);
        }

        let LastName = (document.getElementById("formGridLastName") as HTMLInputElement);
        if (LastName.value == undefined || LastName.value == null || LastName.value.replace(/\s/g, '').length == 0) {
            setLastName(true);
            respReturn = true;
        } else {
            fromData.set('Last Name', LastName.value);
        }

        let email = (document.getElementById("formGridEmail") as HTMLInputElement);
        if (email.value == undefined || email.value == null || email.value.replace(/\s/g, '').length == 0 || !(/^\S+@\S+\.\S+$/).test(email.value)) {
            setEmail(true);
            respReturn = true;
        } else {
            fromData.set('Email', LastName.value)
        }

        let Company = (document.getElementById("formGridCompany") as HTMLInputElement);
        if (Company.value == undefined || Company.value == null || Company.value.replace(/\s/g, '').length == 0) {
            setCompany(true);
            respReturn = true;
        } else {
            fromData.set('Company', Company.value);
        }

        let mobile = (document.getElementById("formGridMobile") as HTMLInputElement);
        if (mobile.value == undefined || mobile.value == null || mobile.value.replace(/\s/g, '').length == 0) {
            setMobile(true);
            respReturn = true;
        } else {
            fromData.set('Mobile', mobile.value);
        }

        let Query = (document.getElementById("#Query") as HTMLInputElement);
        if (Query.value == undefined || Query.value == null || Query.value.replace(/\s/g, '').length == 0) {
            setDescription(true);
            respReturn = true;
        } else {
            fromData.set('Description', Query.value);
        }

        let AboutUs = (document.getElementById("formGridAboutUs") as HTMLInputElement);
        if (AboutUs.value == undefined || AboutUs.value == null || AboutUs.value.replace(/\s/g, '').length == 0) {
            setLeadSource(true);
            respReturn = true;
        } else {
            fromData.set('Lead Source', AboutUs.value);
        }
        return respReturn;
    }



    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    return (

        <div className='container-fluid'>

            <div className='row mt-5 pt-0 pt-lg-3 mb-5 pb-0 pb-lg-3 ms-1 ms-lg-0 me-1 me-lg-0'>
                <div className='col'>
                    <Container className='contactBg'>
                        <div className='row p-2 align-items-center'>
                            {/* <div className='col-auto ' >
                            <div style={{ backgroundImage: `url(${contactBgImage})`}}>                                
                                <div className='contactHeading w-100 ps-4 ps-lg-5 pe-0 pe-lg-5'>
                                    <h2 className='text-start mb-3 mb-lg-5  pb-0 pb-lg-5'>Get in touch with us</h2>

                                    <div className='row mb-3 mb-lg-4'>
                                        <div className='col-auto'>
                                            <img src={call} alt="Call" />
                                        </div>
                                        <div className='col text-start'>
                                            +91 98111 27246
                                        </div>
                                    </div>
                                    <div className='row  mb-3 mb-lg-4'>
                                        <div className='col-auto'>
                                            <img src={email} alt="Email" />
                                        </div>
                                        <div className='col text-start'>
                                            info@superplum.com <br />
                                            business@superplum.com
                                        </div>
                                    </div>
                                    <div className='row  mb-3 mb-lg-4'>
                                        <div className='col-auto'>
                                            <img src={location} alt="Location" />
                                        </div>
                                        <div className='col text-start'>
                                            Plot D, 107, Sector 2, Noida,<br />
                                            Uttar Pradesh - 201301
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div> */}
                            <div className='col-12 col-md-12   col-lg-5 col-xl-4 Contact-Img text-white  mb-4 mb-lg-0 ' style={{ backgroundImage: `url('../../server-build/Images/Contact.png')` }}>
                                <div className='row contactMedium'>
                                    <div className='col'>
                                        <h2 className='pb-0 pb-md-5 mb-5 mb-lg-0 pt-5 ps-lg-4 text-lg-left text-center text-lg-start mt-0 mt-lg-3'>Get in touch with us</h2>
                                        <div className='row mt-0 mt-xl-5'>
                                            <div className='col-12'>


                                                <div className='row mb-4 mb-lg-4 pb-2 pb-lg-0 justify-content-center'>
                                                    <div className='col-auto'>
                                                        <img src='../../server-build/Images/Call.png' alt="Call" />
                                                    </div>
                                                    <div className='col-8 '>
                                                        +91 98111 27246
                                                    </div>
                                                </div>
                                                <div className='row  mb-4 mb-lg-4 pb-2 pb-lg-0  justify-content-center'>
                                                    <div className='col-auto'>
                                                        <img src='../../server-build/Images/Email1.png' alt="Email" />
                                                    </div>
                                                    <div className='col-8 '>
                                                        info@superplum.com <br />
                                                        business@superplum.com
                                                    </div>
                                                </div>
                                                <div className='row  mb-4 mb-lg-4 pb-2 pb-lg-0  justify-content-center'>
                                                    <div className='col-auto'>
                                                        <img src='../../server-build/Images/location.png' alt="Location" />
                                                    </div>
                                                    <div className='col-8'>
                                                        Plot D, 107, Sector 2, Noida,<br />
                                                        Uttar Pradesh - 201301
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <div className='col-12 col-md-12 col-lg-7 col-xl-8 align-self-center ps-1 ps-lg-5 pe-1 pe-lg-5 '>
                                {showMessage != null && showMessage && <div className="alert alert-success" role="alert">
                                    Request sent successfully !!
                                </div>
                                }
                                {showMessage != null && !showMessage && <div className="alert alert-danger" role="alert">
                                    An Error occured while send you request.
                                </div>
                                }
                                {/* <h2 className='contactHeadingText mb-5 d-none d-lg-block'>Looking for a job?</h2> */}
                                <h2 className='contactHeadingText mb-4 d-lg-none'>Drop us a message </h2>
                                <div className='row fw-semibold mb-lg-3'>
                                    <div className='col'>
                                        <Form>
                                            <div className="mb-0 mb-lg-3 row  ">
                                                <Form.Group className='col-12 col-lg mb-5 mb-lg-0 req' controlId="formGridFirstName">
                                                    <Form.Label className='mb-0'>First Name&nbsp;<span className='text-danger'>*</span></Form.Label>
                                                    <Form.Control type="text" />
                                                    {FirstName && <div className='small text-danger' >First Name is required</div>}
                                                </Form.Group>

                                                <Form.Group className='col-12 col-lg mb-5 mb-lg-0' controlId="formGridLastName">
                                                    <Form.Label className='mb-0'>Last Name&nbsp; <span className='text-danger'> *</span></Form.Label>
                                                    <Form.Control type="text" />
                                                    {LastName && <div className='small text-danger'>Last Name is required</div>}
                                                </Form.Group>
                                            </div>
                                            <div className=" row mb-0 mb-lg-3">
                                                <Form.Group className='col-12 col-lg mb-5 mb-lg-0' controlId="formGridEmail">
                                                    <Form.Label className='mb-0'>Email &nbsp;<span className='text-danger'> *</span></Form.Label>
                                                    <Form.Control type="text" />
                                                    {Email && <div className='small text-danger'>Email is required</div>}
                                                </Form.Group>

                                                <Form.Group className='col-12 col-lg mb-5 mb-lg-0' controlId="formGridMobile">
                                                    <Form.Label className='mb-0'>Phone Number &nbsp;<span className='text-danger'> *</span></Form.Label>
                                                    <Form.Control type="text" />
                                                    {Mobile && <div className='small text-danger'>Phone Number is required</div>}
                                                </Form.Group>
                                            </div>
                                            <div className=" row mb-0 mb-lg-3">
                                                <Form.Group className='col-12 col-xl mb-5 mb-lg-3  mb-xl-0' controlId="formGridCompany">
                                                    <Form.Label className='mb-0'>Company &nbsp;<span className='text-danger'> *</span></Form.Label>
                                                    <Form.Control type="text" />
                                                    {Company && <div className='small text-danger'>Company is required</div>}
                                                </Form.Group>

                                                <Form.Group className='col-12 col-xl mb-5 mb-lg-1 mb-xl-0' controlId="formGridAboutUs">
                                                    <Form.Label className='mb-0'>Where did you hear about us? &nbsp;<span className='text-danger'> *</span></Form.Label>
                                                    <Form.Select className='form-control' >
                                                        <option value="-None-">-None-</option>
                                                        <option value="Advertisement">Advertisement</option>
                                                        <option value="Cold Call">Cold Call</option>
                                                        <option value="Employee Referral">Employee Referral</option>
                                                        <option value="External Referral">External Referral</option>
                                                        <option value="Online Store">Online Store</option>
                                                        <option value="Partner">Partner</option>
                                                        <option value="Public Relations">Public Relations</option>
                                                        <option value="Sales Email Alias">Sales Email Alias</option>
                                                        <option value="Seminar Partner">Seminar Partner</option>
                                                        <option value="Internal Seminar">Internal Seminar</option>
                                                        <option value="Trade Show">Trade Show</option>
                                                        <option value="Web Download">Web Download</option>
                                                        <option value="Web Research">Web Research</option>
                                                        <option value="Chat">Chat</option>
                                                        <option value="Twitter">Twitter</option>
                                                        <option value="Facebook">Facebook</option>
                                                        <option value="Google+">Google</option>
                                                    </Form.Select>
                                                    {LeadSource && <div className='small text-danger'>Field is required</div>}
                                                </Form.Group>
                                            </div>

                                            {/* <div className='row mb-5'>
                                            <div className='col'>
                                                <Form.Group  controlId="formBasicCheckbox">
                                                    <Form.Label className='mb-4'>Reason for contacting us:</Form.Label>
                                                    <Form.Check className='mb-4 contactText' type="checkbox" label="Looking for a job " />
                                                    <Form.Check  className='mb-4 contactText' type="checkbox" label="Interested in partnering with us  " />
                                                    <Form.Check  className=' contactText' type="checkbox" label="Interested in exports" />
                                                </Form.Group>
                                            </div>
                                        </div> */}

                                            <div className='row'>
                                                <div className='col-12 col-lg mb-lg-0'>
                                                    <Form.Label>Your Query &nbsp; <span className='text-danger'> *</span></Form.Label>
                                                    <Form.Control id="#Query" type="text" placeholder="Write Your Message..." className='contact-message' />
                                                    {Description && <div className='small text-danger' >Your Query is required</div>}
                                                </div>
                                            </div>

                                        </Form>
                                    </div>
                                </div>
                                {/* <div className='row ps-4  pe-4 ps-lg-3 pe-lg-4'>
                                    <div className='col'>
                                        {/* <div className='row'>
                                        <div className='col ps-0'>
                                        <p className='mt-4 d-flex align-items-center fw-bold'> <FontAwesomeIcon icon={faChevronLeft} className='border p-1 me-2 rounded fa-xs ' style={{ color: '#64748b' }} /> Upload resume </p>                                 
                                        </div>
                                    </div> 
                                        <div className='row align-items-center justify-content-between ' >
                                            {/* <div className='col-12 col-lg-8 text-center bg-white pt-3 pb-3 contactBorderStyle'>
                                            <img src={upload} alt="Upload" />
                                            <p>Browse and choose the files you want to upload from your computer</p>
                                            <img src={add} alt="Add" onClick={() => document.getElementById('fileInput').click()} style={{ cursor: 'pointer' }} />
                                            <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleFileChange} />
                                        </div> 
                                            <div className='col-12 col-lg-4  mt-5 mt-lg-3 pt-0 pt-lg-2 pt-xl-4 pb-4 pb-lg-0 ps-0' >
                                                {!isLoading && <Button variant="outline-secondary" className='me-2 rounded-pill blackButton btn-lg ' onClick={() => submit()}>Submit</Button>}
                                                {isLoading && <Button variant="outline-secondary" className='me-2 rounded-pill blackButton btn-lg fw-bold'>
                                                    <div className="spinner-border text-light" role="status">

                                                    </div>
                                                </Button>}
                                            </div>
                                        </div>
                                    </div>
                                </div>*/}

                                <div className='row ps-4  pe-4 ps-lg-3 pe-lg-4 justify-content-center justify-content-lg-start'>
                                    <div className='col-auto col-lg-4  mt-5 mt-lg-3 pt-0 pt-lg-2 pt-xl-4 pb-4 pb-lg-0 ps-0 pe-0' >
                                        {!isLoading && <Button variant="outline-secondary" className='rounded-pill blackButton  ' onClick={() => submit()}>Submit</Button>}
                                        {isLoading && <Button variant="outline-secondary" className='me-2 rounded-pill blackButton btn-lg fw-bold'>
                                            <div className="spinner-border text-light" role="status">

                                            </div>
                                        </Button>}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </Container>
                </div>
            </div>


        </div>
    );
}

export default Contact;
